document.addEventListener('DOMContentLoaded', (event) => {
    // Select the radio input elements by name
    const subscriptionRadioInputs = document.getElementsByName('bsub-selling-plan-group');
    console.log(subscriptionRadioInputs)
    // Check if there are any radio inputs with the specified name
    if(subscriptionRadioInputs.length > 0) {
        // Set the 'checked' attribute to true for the first radio input with the specified name
        subscriptionRadioInputs[1].checked = true;
    }
});
